<template>
  <div>
    <headers v-if="true"></headers>
    <router-view />
    <footers v-if="true"></footers>
  </div>
</template>

<script>
import headers from './HeaderSection'
import footers from './FooterSection'
export default {
  components: {
    headers,
    footers
  }
}
</script>

<style>

</style>